import forge from 'node-forge'

//restful api
import { report as wsfinder } from '@/service/api/wsfinder'
import { webshell } from '@/service/api/wsfinder'
import { group as manager } from '@/service/api/manager'

export default {
  data : () => {
    return {
      reject_confirm: false,
      approve_confrm: false,
      model : { is_binary : false },
      decrypted : false,
      content : '',
      content_type : '',
      group_id : '',
      group_model : {},
    }
  },
  computed: {
    startRow() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    decrypt : function() {
      try {
        // 바이너리일 경우 강제 내용 보기
        let data = this.model.content.split(',')[1]
        let content = forge.util.decode64(data)
        try {
          this.content = forge.util.decodeUtf8(content) // 한글 처리
        } catch (error) { this.content = unescape(content) }

      } catch (e) { this.$toastr.e('decode failed', 'not support this format') }
      finally { this.decrypted = true }
    },
    approve: function() { //등록 부분
      this.lock = true;
      // Api.Manager_Call('wsfinder.webshell','approve', this.model)
      webshell.approveWebshell(this.model)
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('approved.'), this.list(); this.$emit('refresh')
          } else {
            console.log("approve", 'failed', rs.description, this.model.id)
            this.$toastr.e('approve', "failed")
          }
          this.$emit('refresh');
          this.lock = false;
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    reject: function() {
      this.lock = true;
      // Api.Manager_Call('wsfinder.webshell','reject', this.model)
      webshell.rejectWebshell(this.model)
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('rejected.'), this.list();
          } else {
            console.log("rejected", 'failed', rs.description, this.model.id)
            this.$toastr.e('rejected', "failed")
          }
          this.$emit('refresh');
          this.lock = false;
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    remove: function() {
      // Api.Manager_Call('wsfinder.report','delete', { id : this.model.id})
      wsfinder.deleteReport({ id : this.model.id})
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.description, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
      }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    list: function() { this.lock = false; this.$router.push({ name: 'wsfinder_submitted'}); },
    get: function(id = this.$route.params.id) {
      console.log('report.detail.vue', 'load item', id);
      wsfinder.detailReport({id:id}).then(data => { this.model = Object.assign({}, this.model, data.body); })
      .then(() => {
        let type = this.model.content.split(';')[0];
        if(type) { this.content_type = type.replace('data:', '') }
        if (this.model.is_binary){ console.log('is_binary'); }
        else {
          let content = forge.util.decode64(this.model.content.split(',')[1], 'base64');
          this.model.content = forge.util.decodeUtf8(content)
        }

        //group_info 를 가져오기 위해 필요
        this.group_id = this.model.group_id
        manager.detailGroup({ id : this.group_id }).then(rs => this.group_model = Object.assign({ group: {} }, this.group_model, rs.body));
      })
      .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('report.detail.vue', 'created'); },
  destroyed: function() { console.log('report.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('report.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}